import { shrpaApi } from "./axios";

// Types
import { CollabInput, DestinationContactUpdatePayload } from "@contracts/collab";

export default {
  async loadHighlights(communityId: string, collabInputId: string, creatorId: string): Promise<string[]> {
    if (!creatorId) return [];

    const uri = `/collabs/${communityId}/inputs/${collabInputId}/creator/${creatorId}/highlights`;

    const response = await shrpaApi.get<string[]>(uri);
    return response.data;
  },
  async loadCustomerCollabs(customerId: string): Promise<Array<CollabInput>> {
    const uri = `/collabs/${customerId}`;
    const { data } = await shrpaApi.get<Array<CollabInput>>(uri);

    return data;
  },

  async loadAnonymousGuidanceSummary(communityId: string, collabInputId: string): Promise<CollabInput> {
    const uri = `/collabs/${communityId}/inputs/${collabInputId}/guidance-summary`;
    const { data } = await shrpaApi.get<Array<CollabInput>>(uri);

    return data;
  },

  async updateDestinationContact(customerId: string, collabInputId: string, payload: DestinationContactUpdatePayload): Promise<CollabInput> {
    const uri = `/collabs/${customerId}/inputs/${collabInputId}/destination-contact`;
    const { data } = await shrpaApi.put<CollabInput>(uri, payload);
    return data;
  },
};
